export const enum DocumentTypeValues {
    CAD = "CAD",
    Catalog = "CATALOG",
    Downloads = "Downloads"
}

export const enum DocumentNameValues {
    CAD = "CAD",
}
